import { render, staticRenderFns } from "./ConfigSubmitDialog.vue?vue&type=template&id=681ace44&scoped=true"
import script from "./ConfigSubmitDialog.vue?vue&type=script&lang=js"
export * from "./ConfigSubmitDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfigSubmitDialog.vue?vue&type=style&index=0&id=681ace44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681ace44",
  null
  
)

export default component.exports